<template>
  <section class="partners reveal" id="aliados">
    <div class="section-header">
      <span class="section-label">Confían en Nosotros</span>
      <h2 class="section-title">Aliados Estratégicos</h2>
      <p class="section-subtitle">Organizaciones que caminan junto a nosotros en esta misión de transformación.</p>
    </div>

    <div class="marquee-container">
      <div class="marquee-content">
        <!-- Double the items for seamless loop -->
        <div class="partner-item" v-for="(partner, i) in [...partners, ...partners]" :key="i">
          <div class="logo-box">
            <span class="partner-name">{{ partner }}</span>
            <div class="logo-shimmer"></div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
const partners = ['Iglesia Central', 'FUNDAP', 'World Vision', 'Compassion', 'ASECSA', 'Alianza Evangelica', 'Misión Global'];
</script>

<style scoped>
.partners {
  background: var(--vh-blanco);
  padding: 8rem 0;
  overflow: hidden;
}

.marquee-container {
  position: relative;
  width: 100%;
  padding: 2rem 0;
  display: flex;
}

.marquee-content {
  display: flex;
  gap: 3rem;
  animation: scroll 30s linear infinite;
  width: max-content;
}

.marquee-container:hover .marquee-content {
  animation-play-state: paused;
}

.partner-item {
  flex: 0 0 auto;
}

.logo-box {
  background: white;
  border: 1px solid rgba(0,0,0,0.05);
  padding: 2rem 3.5rem;
  border-radius: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 220px;
  height: 100px;
  box-shadow: 0 10px 30px rgba(0,0,0,0.03);
  position: relative;
  overflow: hidden;
  transition: var(--vh-transicion);
}

.logo-box:hover {
  transform: translateY(-5px);
  box-shadow: 0 15px 40px rgba(26, 75, 140, 0.1);
  border-color: var(--vh-dorado);
}

.partner-name {
  font-family: 'League Spartan', sans-serif;
  font-size: 1.2rem;
  font-weight: 700;
  color: var(--vh-azul-profundo);
  opacity: 0.7;
  transition: var(--vh-transicion);
}

.logo-box:hover .partner-name {
  opacity: 1;
  color: var(--vh-dorado);
}

.logo-shimmer {
  position: absolute;
  top: 0;
  left: -100%;
  width: 50%;
  height: 100%;
  background: linear-gradient(
    90deg,
    transparent,
    rgba(255, 255, 255, 0.4),
    transparent
  );
  transform: skewX(-20deg);
  transition: 0.5s;
}

.logo-box:hover .logo-shimmer {
  left: 150%;
  transition: 0.7s;
}

@keyframes scroll {
  0% { transform: translateX(0); }
  100% { transform: translateX(calc(-50% - 1.5rem)); }
}

/* Section Header overrides if needed */
.section-header {
  margin-bottom: 4rem;
}

@media (max-width: 768px) {
  .partners { padding: 5rem 0; }
  .logo-box { padding: 1.5rem 2.5rem; min-width: 180px; }
  .partner-name { font-size: 1rem; }
}
</style>
